import { AnnatureForm } from '@fastre/core/schemas/annature'
import { EsignFormStructure } from '@fastre/core/schemas/esign'
import { Link, Stack, Table, Typography } from '@mui/joy'
import { useUserData } from 'auth'
import PdfModal from 'components/pdfModal'
import { useOrgId } from 'helpers'
import DocusignFormStepper from 'listings/docusignFormStepper'
import { useListingContext } from 'listings/listingProvider'
import { useState } from 'react'

export default () => {
    const { user } = useUserData()
    const orgId = useOrgId()
    const { listing, refreshListing } = useListingContext()

    const [pdfFile, setPdfFile] = useState<string>()

    const tabValues = {} /*listing.fundDisbursementForm?.actions
        ?.map(prop('fields'))
        ?.flat()
        ?.filter(hasValue)
        ?.map(field => ({
            [field.label]: field.value,
        }))
        .reduce(reduceToObject, {})*/

    if (user.docusign != undefined && !user.fundDisbursementFormConfigured) {
        if (user.permissions.includes('settings.edit')) {
            return (
                <>
                    <Typography
                        level="h4"
                        sx={{ mt: 20 }}
                    >
                        Fund Disbursement Form
                    </Typography>
                    <Typography sx={{ mt: 2 }}>
                        <Link href={`/${orgId}/settings?tab=Fund+Disbursement+Template`}>Configure</Link> your
                        fund disbursement form to create, send and view forms
                    </Typography>
                </>
            )
        }
    }

    return (
        <>
            <DocusignFormStepper
                title="Fund Disbursement Form"
                formType="fundDisbursementForm"
                validate={() => true}
                preCreate={() => Promise.resolve(true)}
                signingService="annature"
                createDisabled={
                    !listing.balanceSheet?.some(x => x.externalRef == 'vendorBalance') ||
                    listing.vendors.length == 0
                }
                roleNames={listing.vendors.map((vendor, i) => `${vendor.firstName} ${vendor.lastName}`)}
            />
            {listing.fundDisbursementForm && (
                <Stack sx={{ mt: 4 }}>
                    {listing.fundDisbursementForm.esign?.formStatus == 'completed' && (
                        <>
                            <Typography
                                level="h4"
                                sx={{ fontSize: 20, mb: 2 }}
                            >
                                Bank Details
                            </Typography>
                            <Table sx={{ maxWidth: 400 }}>
                                <tbody>
                                    {[
                                        ['Bank Name', 'bank'],
                                        ['Account Name', 'accountName'],
                                        ['BSB', 'bsb'],
                                        ['Account Number', 'accountNumber'],
                                    ].map(([label, value]) => (
                                        <tr>
                                            <td style={{ width: 150 }}>{label}</td>
                                            <td>
                                                {
                                                    (
                                                        (listing.fundDisbursementForm as EsignFormStructure)
                                                            ?.esign as AnnatureForm
                                                    )?.fields?.[value]
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </>
                    )}
                </Stack>
            )}
            <PdfModal
                title="Fund Disbursement Form"
                pdf={pdfFile}
                onClose={() => setPdfFile(undefined)}
                fileName="fund-disbursement-form"
                withAuth
            />
        </>
    )
}
